import React, { useState, useEffect } from "react";
import { FaRegWindowClose } from "react-icons/fa";
import { IoIosAddCircleOutline, IoIosCheckmarkCircleOutline } from "react-icons/io";
import { IoCloseCircleOutline } from "react-icons/io5";
import { BsClock } from "react-icons/bs";
import Loading from "../../component/Loading/Loading";
import { useSelector } from "react-redux";
import { FaSearch } from "react-icons/fa";
import { formattedDate } from "../../utils/dateUtils";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { CgCloseR } from "react-icons/cg";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import AlertMsg from '../../component/AlertMsg/AlertMsg';
import { AiOutlineSortAscending } from "react-icons/ai";
import Pagination from "../../utils/Pagenation/Pagenation";
import useAxiosInstance from "../../services/useAxiosInstance";
import { Eye, Pencil, Trash2, Plus, Search, X, Upload, FileText } from "lucide-react";
import GlassmorphicModal from "../../component/ReusableComponents/GlassmorphicModal";

const Violations = () => {
    const [clearBtnshow, setClearBtnshow] = useState(false);
    const axiosInstance = useAxiosInstance();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [violationTypes, setViolationTypes] = useState([]);
    const [clients, setClients] = useState([]);
    const currentDate = new Date();
    const formattedDates = currentDate.toISOString();
    const communityId = useSelector((state) => state.auth.communityId);
    const userId = useSelector((state) => state.auth.userId);
    const roleId = useSelector((state) => state.auth.roleId);
    const clientIds = useSelector((state) => state.auth.clientId);
    const [showViewModal, setShowViewModal] = useState(false);
    const [selectedViolation, setSelectedViolation] = useState(null);

    const [alert, setAlert] = useState({ visible: false, message: '', type: '' });

    const displayValue = (value) => {
        return value === 0 ? "" : value;
    };

    const [formData, setFormData] = useState({
        activeStatus: true,
        amount: "",
        clientId: 0,
        communityId: communityId,
        createdById: userId,
        createdDate: formattedDates,
        modifiedById: null,
        modifiedDate: formattedDates,
        remarks: "",
        violationDate: "",
        violationId: 0,
        violationStatusId: 2,
        violationTypeId: 0
    });

    const [formDocumentData, setFormDocumentData] = useState({
        activeStatus: true,
        communityId: communityId,
        createdByDate: new Date().toISOString(),
        createdById: userId,
        description: "",
        docUrl: "",
        violationDocumentId: 0,
        violationId: 0
    });
    const [formErrors, setFormErrors] = useState({});
    const [currentPage, setCurrentPage] = useState(0);
    const [itemsPerPage] = useState(5);
    const [searchTerm, setSearchTerm] = useState("");

    const communityIdget = communityId;

    let clientIdget;
    if (roleId === 1001 || roleId === 1002) {
        clientIdget = 0;
    } else if (roleId === 1003) {
        clientIdget = clientIds;
    }

    console.log(communityIdget);
    console.log(userId);

    const getTodayDate = () => {
        const today = new Date();
        console.log(today);
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };
    console.log(getTodayDate);

    const getPreviousSeventhDate = () => {
        const today = new Date();
        today.setDate(today.getDate() - 7);

        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    };

    const sevenDaysAgo = getPreviousSeventhDate(7);
    console.log(sevenDaysAgo);

    const [startDate, setStartDate] = useState(getTodayDate());
    const [endDate, setEndDate] = useState(getPreviousSeventhDate());
    const [violationStatusId, setViolationStatusId] = useState(0);
    const [statuses, setStatuses] = useState([]);

    useEffect(() => {
        const fetchviolationStatus = async () => {
            try {
                const responseStatuses = await axiosInstance.get(
                    `/api/violationStatus/getAll`
                );
                setStatuses(responseStatuses.data);

            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchviolationStatus();
    }, []);

    const fetchViolationData = async () => {
        setLoading(true);
        try {
            const response = await axiosInstance.get(`/api/violation/CommunityIdAndCreatedById`, {
                params: {
                    communityId: communityIdget,
                    clientId: clientIdget,
                    endDate: endDate,
                    startDate: startDate,
                    violationStatusId: violationStatusId,
                }
            });
            setData(response.data);
            console.log(response.data);
            setLoading(false);
            setDisplayedData(response.data);
        } catch (error) {
            console.error('Error fetching data', error);
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchViolationData();
    }, [communityIdget, clientIdget, endDate, startDate, violationStatusId]);

    useEffect(() => {
        const fetchViolationTypes = async () => {
            try {
                const response = await axiosInstance.get(
                    `/api/violationtype/findByCommunityId/${communityId}`
                );
                // Filter the data to only include active violations
                const activeViolations = response.data.filter(
                    (violation) => violation.activeStatus === true
                );
                setViolationTypes(activeViolations);
            } catch (error) {
                if (error.response) {
                    console.error('Error response data:', error.response.data);
                    console.error('Error status:', error.response.status);
                    console.error('Error headers:', error.response.headers);
                } else if (error.request) {
                    console.error('Error request:', error.request);
                } else {
                    console.error('Error message:', error.message);
                }
                console.error("Error fetching violation types:", error);
            }
        };

        fetchViolationTypes();
    }, [communityId]);

    useEffect(() => {
        if (!communityId) return;

        const fetchClients = async () => {
            try {
                const response = await axiosInstance.get(`/api/user/getUsersList/${communityId}`);
                if (response.status === 200) {
                    const activeUsers = response.data.filter(user => user.activeStatus === true || user.activeStatus === "true");
                    console.log(response.data);
                    console.log("Filtered active users:", activeUsers);
                    setClients(activeUsers);
                } else {
                    throw new Error(`Unexpected response status: ${response.status}`);
                }
            } catch (error) {
                console.error("Error fetching clients:", error);
            }
        };

        fetchClients();
    }, [communityId]);

    const getStatusColor = (status) => {
        switch (status) {
            case "Cancelled":
                return "#676765";
            case "Submitted":
                return "rgb(15 209 120)";
            case "In Progress":
                return "#B5850B";
            case "Completed":
                return "rgb(15 209 120)";
            default:
                return "#000000";
        }
    };

    const getStatusIcon = (status) => {
        switch (status) {
            case "Cancelled":
                return <IoCloseCircleOutline />;
            case "Submitted":
            case "Completed":
                return <IoIosCheckmarkCircleOutline />;
            case "In Progress":
                return <BsClock />;
            default:
                return null;
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "violationDate") {
            const formattedDate = new Date(value).toISOString();
            setFormData((prevState) => ({
                ...prevState,
                [name]: formattedDate,
            }));
        } else if (name === 'violationTypeId') {
            const selectedViolationType = violationTypes.find(violation => violation.violationTypeId === parseInt(value, 10));
            const amount = selectedViolationType ? selectedViolationType.amount : 0;
            setFormData(prevState => ({
                ...prevState,
                amount: amount,
                [name]: parseInt(value, 10),
            }));
        } else if (name === 'clientId') {
            setFormData(prevState => ({
                ...prevState,
                [name]: parseInt(value, 10),
            }));
        } else {
            setFormData(prevState => ({
                ...prevState,
                [name]: value,
            }));
        }
    };

    const validateForm = () => {
        let errors = {};
        if (!formData.clientId) errors.clientId = "clientId is required";
        if (!formData.violationTypeId) errors.violationTypeId = "Violation Type is required";
        if (!formData.amount || formData.amount <= 0) errors.amount = "Amount is required and must be greater than 0";
        if (!formData.remarks) errors.remarks = "Remarks are required";
        if (!formData.violationDate || new Date(formData.violationDate).toString() === "Invalid Date") {
            errors.violationDate = "Violation Date is required and must be a valid date";
        }
        return errors;
    };

    const [selectedFile, setSelectedFile] = useState(null);

    const handleFileChange = (event) => {
        setSelectedFile(event.target.files[0]);
    };

    const handleSubmit = async (e) => {
        setLoading(true);
        e.preventDefault();
        const errors = validateForm();
        if (Object.keys(errors).length > 0) {
            setFormErrors(errors);
            setLoading(false);
            return;
        }
        setShowModal(false);
        let newDocUrl = formData.docUrl;

        if (selectedFile) {
            const uploadFormData = new FormData();
            uploadFormData.append('file', selectedFile);

            try {
                const uploadResponse = await axiosInstance.post(
                    `/api/violationDocument/violationUpload`,
                    uploadFormData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
                );
                newDocUrl = uploadResponse.data;
                console.log(newDocUrl);

            } catch (error) {
                console.error('Error uploading file', error);
                setLoading(false);
                setAlert({ visible: true, message: 'Error uploading file. Please try again.', type: 'error' });
                return;
            }
        }

        try {
            console.log("9849");
            const response = await axiosInstance.post(`/api/violation/add`, formData);
            fetchViolationData();
            console.log("9849");
            console.log(response.data);

            console.log("9849");
            const result = response.data;
            const violationId = result.violationId;

            console.log("9849");

            const updatedFormDocumentData = {
                ...formDocumentData,
                violationId: violationId,
                docUrl: newDocUrl,
            };
            console.log(updatedFormDocumentData);

            const documentResponse = await axiosInstance.post(`/api/violationDocument/add`, updatedFormDocumentData);
            fetchViolationData();
            handleCancel();
            setAlert({ visible: true, message: 'Violation submitted successfully!', type: 'success' });
            setFormErrors({});

        } catch (error) {
            console.error("Error adding violation or document:", error.response?.data?.message || error.message);
            setAlert({
                visible: true,
                message: error.response?.data?.message || 'Error adding violation or document. Please try again.',
                type: 'error'
            });
        }
        finally {
            setLoading(false);
        }
    };

    const handleCancel = () => {
        setShowModal(false);
        setFormData({
            activeStatus: true,
            amount: "",
            clientId: 0,
            communityId: communityId,    // Keep communityId unchanged
            createdById: userId,         // Keep createdById unchanged
            createdDate: formattedDates, // Keep createdDate unchanged
            modifiedById: null,
            modifiedDate: formattedDates,
            remarks: "",
            violationDate: "",
            violationId: 0,
            violationStatusId: 2,
            violationTypeId: 0
        });

        // Reset formDocumentData to initial values
        setFormDocumentData({
            activeStatus: true,
            communityId: communityId,            // Keep communityId unchanged
            createdByDate: new Date().toISOString(), // Reset created date
            createdById: userId,                 // Keep createdById unchanged
            description: "",
            docUrl: "",
            violationDocumentId: 0,
            violationId: 0
        });

        setFormErrors({});
        setSelectedFile(null);
        // Clear file input if it exists
        const fileInput = document.querySelector('input[type="file"]');
        if (fileInput) fileInput.value = null;
    };

    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
        setClearBtnshow(true);
    };

    useEffect(() => {
        const filteredData = data.filter((item) => {
            const violationTypeMatch = item.violationTypeName.toLowerCase().includes(searchTerm.toLowerCase());
            const clientNameMatch = item.clientName.toLowerCase().includes(searchTerm.toLowerCase());
            const clientAddressMatch = item.clientAddress.toLowerCase().includes(searchTerm.toLowerCase());

            return violationTypeMatch || clientNameMatch || clientAddressMatch;
        });

        setDisplayedData(filteredData);
    }, [data, searchTerm]);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };
    const [displayedData, setDisplayedData] = useState([]);
    const [sortField, setSortField] = React.useState('violationDate');
    const [sortOrder, setSortOrder] = React.useState('asc');

    const handleSort = (field) => {
        const newSortOrder = (field === sortField && sortOrder === 'asc') ? 'desc' : 'asc';
        setSortField(field);
        setSortOrder(newSortOrder);
    };
    const sortedData = React.useMemo(() => {
        return [...displayedData].sort((a, b) => {
            if (sortField === 'clientName') {
                const nameA = a.clientName.toLowerCase();
                const nameB = b.clientName.toLowerCase();
                if (nameA < nameB) return sortOrder === 'asc' ? -1 : 1;
                if (nameA > nameB) return sortOrder === 'asc' ? 1 : -1;
                return 0;
            }
            const dateA = new Date(a.violationDate);
            const dateB = new Date(b.violationDate);
            return sortOrder === 'asc' ? dateA - dateB : dateB - dateA;
        });
    }, [displayedData, sortField, sortOrder]);

    const getPaginatedData = () => {
        const startIndex = currentPage * itemsPerPage;
        return sortedData.slice(startIndex, startIndex + itemsPerPage);
    };
    const paginatedData = getPaginatedData();
    console.log(paginatedData);

    const pageCount = Math.ceil(displayedData.length / itemsPerPage);

    const handleCloseViewModal = () => {
        setShowViewModal(false);
        setSelectedViolation(null);
    };

    const handleViewClick = (violation) => {
        setSelectedViolation(violation);
        setShowViewModal(true);
    };

    const [showApprovalModal, setShowApprovalModal] = useState(false);

    const openApprovalModal = () => {
        setShowApprovalModal(true);
    };
    const closeModal = () => {
        setShowApprovalModal(false);
    };

    const [filterData, setFilterData] = useState({
        startDates: getTodayDate(),
        endDates: getPreviousSeventhDate(),
        violationStatusIds: 0
    });

    const handleStartDateChange = (event) => {
        const newStartDate = event.target.value;
        setFilterData(prev => ({
            ...prev,
            startDates: newStartDate,
            endDates: (prev.endDates && newStartDate > prev.endDates) ? '' : prev.endDates
        }));
    };

    const handleEndDateChange = (event) => {
        setFilterData({
            ...filterData,
            endDates: event.target.value
        });
    };

    const handleviolationStatusId = (event) => {
        setFilterData({
            ...filterData,
            violationStatusIds: event.target.value
        });
    };
    const handleSearchfilter = () => {
        setStartDate(filterData.startDates);
        setEndDate(filterData.endDates);
        setViolationStatusId(filterData.violationStatusIds);
        setCurrentPage(0);
        setClearBtnshow(true);
    };

    const clearFilters = () => {
        setStartDate(getTodayDate());
        setEndDate(getPreviousSeventhDate());
        setViolationStatusId(0);
        setSearchTerm('');
        setFilterData({
            startDates: getTodayDate(),
            endDates: getPreviousSeventhDate(),
            violationStatusIds: 0
        })
        setCurrentPage(0);
        setClearBtnshow(false);
    };

    // Modal footers
    const viewModalFooter = (
        <div className="flex justify-end">
            <button
                className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
                onClick={handleCloseViewModal}
            >
                Close
            </button>
        </div>
    );

    const approvalModalFooter = (
        <div className="flex justify-end space-x-2">
            <button
                className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
                onClick={closeModal}
            >
                Cancel
            </button>
            <button
                className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
                onClick={closeModal}
            >
                Confirm
            </button>
        </div>
    );

    // Add Violation Modal Footer
    const addViolationModalFooter = (
        <div className="flex justify-end space-x-2">
            <button
                type="button"
                className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
                onClick={handleCancel}
            >
                Cancel
            </button>
            <button
                type="button"
                className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
                onClick={handleSubmit}
            >
                Submit
            </button>
        </div>
    );

    return (
        <div className="bg-gray-50 min-h-screen md:p-4">
            {loading && <Loading />}
            {!loading && (
                <div className="max-w-7xl mx-auto">
                    {alert.visible && (
                        <AlertMsg
                            message={alert.message}
                            type={alert.type}
                            onClose={() => setAlert({ ...alert, visible: false })}
                        />
                    )}
                    <div className="flex justify-between items-center mb-6">
                        <h1 className="text-2xl font-bold text-gray-800">Violations</h1>
                        <div className="flex items-center">
                            {(roleId === 1001 || roleId === 1002) && (
                                <button
                                    className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md flex items-center gap-2"
                                    onClick={() => setShowModal(true)}
                                >
                                    <Plus size={18} />
                                    <span>Add Violation</span>
                                </button>
                            )}
                        </div>
                    </div>

                    <div className="bg-white rounded-lg shadow-sm overflow-hidden mb-6">
                        <div className="flex flex-wrap md:flex-nowrap justify-between items-center p-4">
                            <div className="relative w-full md:w-80 mb-4 md:mb-0">
                                <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                                    <Search className="h-5 w-5 text-gray-400" />
                                </div>
                                <input
                                    type="text"
                                    placeholder="Search by violation..."
                                    value={searchTerm}
                                    onChange={handleSearch}
                                    className="pl-10 pr-4 py-2 border border-gray-300 rounded-md w-full focus:outline-none focus:ring-2 focus:ring-blue-500"
                                />
                            </div>
                            <div className="flex flex-wrap md:flex-nowrap items-center gap-2 w-full md:w-auto">
                                <div className="flex flex-wrap md:flex-nowrap gap-2 w-full md:w-auto">
                                    <input
                                        type="date"
                                        name="startDates"
                                        value={filterData.startDates}
                                        onChange={handleStartDateChange}
                                        max={filterData.endDates || ''}
                                        className="border border-gray-300 rounded-md p-2 text-sm w-full md:w-auto flex-1 md:flex-none"
                                    />
                                    <input
                                        type="date"
                                        name="endDates"
                                        value={filterData.endDates}
                                        onChange={handleEndDateChange}
                                        min={filterData.startDates || new Date().toISOString().split('T')[0]}
                                        className="border border-gray-300 rounded-md p-2 text-sm w-full md:w-auto flex-1 md:flex-none"
                                    />
                                </div>
                                <div className="w-full md:w-auto flex-1 md:flex-none">
                                    <select
                                        name="violationStatusIds"
                                        id="violationStatusIds"
                                        value={filterData.violationStatusIds}
                                        onChange={(e) => setFilterData({ ...filterData, violationStatusIds: e.target.value })}
                                        className="border border-gray-300 rounded-md p-2 text-sm w-full"
                                    >
                                        <option value="">Select Status</option>
                                        {statuses.map((status) => (
                                            <option
                                                key={status.violationStatusId}
                                                value={status.violationStatusId}
                                            >
                                                {status.violationStatus}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="flex flex-wrap gap-2 w-full md:w-auto">
                                    <button
                                        onClick={handleSearchfilter}
                                        className="bg-blue-500 text-white rounded-md px-4 py-2 text-sm hover:bg-blue-600 flex-1 md:flex-none"
                                    >
                                        Search
                                    </button>
                                    {clearBtnshow && (
                                        <button
                                            onClick={clearFilters}
                                            className="bg-gray-500 text-white rounded-md px-4 py-2 text-sm hover:bg-gray-600 flex-1 md:flex-none"
                                            title="Clear Filter"
                                        >
                                            Clear
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="overflow-x-auto">
                            <table className="min-w-full divide-y divide-gray-200">
                                <thead className="bg-blue-400">
                                    <tr>
                                        <th
                                            className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider cursor-pointer"
                                            onClick={() => handleSort('clientName')}
                                        >
                                            Client Name <AiOutlineSortAscending className="inline ml-1" />
                                        </th>
                                        <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">Client Address</th>
                                        <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">Violation Type Name</th>
                                        <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">Violation Date</th>
                                        <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">$ Amount</th>
                                        <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">Violation Status</th>
                                        <th className="px-6 py-3 text-left text-sm font-medium text-white tracking-wider">Action</th>
                                    </tr>
                                </thead>
                                <tbody className="bg-white divide-y divide-gray-200">
                                    {getPaginatedData().length === 0 ? (
                                        <tr>
                                            <td colSpan="7" className="px-6 py-4 text-center text-sm text-gray-500">No Data Found</td>
                                        </tr>
                                    ) : getPaginatedData().map((item) => (
                                        <tr key={item.violationId} className="hover:bg-gray-50">
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item.clientName}</td>
                                            <td className="px-6 py-4 text-sm text-gray-900">
                                                {item.clientAddress
                                                    ?.match(/.{1,20}/g) // splits the string into chunks of 1 to 20 characters
                                                    .map((line, index) => (
                                                        <div key={index}>{line}</div>
                                                    ))}
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item.violationTypeName}</td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{formattedDate(item.violationDate)}</td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item.amount}.00</td>
                                            <td
                                                className="px-6 py-4 whitespace-nowrap text-sm font-medium flex items-center"
                                                style={{ color: getStatusColor(item.violationCurrentStatus) }}
                                            >
                                                {getStatusIcon(item.violationStatusName)} <span className="ml-1">{item.violationStatusName}</span>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                                                <Link to={`/violation-details/${item.violationId}`}>
                                                    <Eye
                                                        size={18}
                                                        className="text-blue-500 hover:text-blue-700 cursor-pointer"
                                                        title="View Violation"
                                                    />
                                                </Link>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>

                        <div className="bg-gray-50 px-6 py-3 flex items-center justify-between border-t border-gray-200">
                            <div className="text-sm text-gray-700">
                                Page {currentPage + 1} of {pageCount}
                            </div>
                            <div className="flex-1 flex justify-end">
                                <Pagination
                                    currentPage={currentPage}
                                    pageCount={pageCount}
                                    setCurrentPage={setCurrentPage}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Add Violation Modal using GlassmorphicModal */}
            <GlassmorphicModal
                isOpen={showModal}
                onClose={handleCancel}
                title="Add Violation"
                size="lg"
                footer={addViolationModalFooter}
            >
                <form onSubmit={(e) => { e.preventDefault(); handleSubmit(e); }} className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="md:col-span-1">
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            HOA Member Name <span className="text-red-500">*</span>
                        </label>
                        <select
                            name="clientId"
                            value={formData.clientId}
                            onChange={handleChange}
                            maxLength={100}
                            className={`w-full rounded-md border ${formErrors.clientId ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                        >
                            <option value="">Select Client</option>
                            {clients.map((client) => (
                                <option key={client.clinetId} value={client.clinetId}>
                                    {client.firstName}
                                </option>
                            ))}
                        </select>
                        {formErrors.clientId && <p className="text-red-500 text-xs mt-1">{formErrors.clientId}</p>}
                    </div>

                    <div className="md:col-span-1">
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Violation Type <span className="text-red-500">*</span>
                        </label>
                        <select
                            name="violationTypeId"
                            value={formData.violationTypeId}
                            onChange={handleChange}
                            className={`w-full rounded-md border ${formErrors.violationTypeId ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                        >
                            <option value="">Select Violation Type</option>
                            {violationTypes.map((violation) => (
                                <option key={violation.violationTypeId} value={violation.violationTypeId}>
                                    {violation.name}
                                </option>
                            ))}
                        </select>
                        {formErrors.violationTypeId && <p className="text-red-500 text-xs mt-1">{formErrors.violationTypeId}</p>}
                    </div>

                    <div className="md:col-span-1">
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Violation Date <span className="text-red-500">*</span>
                        </label>
                        <input
                            type="date"
                            name="violationDate"
                            value={formData.violationDate.split('T')[0] || ""}
                            onChange={handleChange}
                            className={`w-full rounded-md border ${formErrors.violationDate ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                            max={new Date().toISOString().split("T")[0]}
                        />
                        {formErrors.violationDate && <p className="text-red-500 text-xs mt-1">{formErrors.violationDate}</p>}
                    </div>

                    <div className="md:col-span-1">
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Amount <span className="text-red-500">*</span>
                        </label>
                        <input
                            type="number"
                            name="amount"
                            maxLength={10}
                            value={displayValue(formData.amount)}
                            onChange={handleChange}
                            className={`w-full rounded-md border ${formErrors.amount ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                            readOnly
                        />
                        {formErrors.amount && <p className="text-red-500 text-xs mt-1">{formErrors.amount}</p>}
                    </div>

                    <div className="md:col-span-2">
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Remarks <span className="text-red-500">*</span>
                        </label>
                        <input
                            type="text"
                            name="remarks"
                            maxLength={200}
                            value={formData.remarks}
                            onChange={handleChange}
                            className={`w-full rounded-md border ${formErrors.remarks ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                        />
                        {formErrors.remarks && <p className="text-red-500 text-xs mt-1">{formErrors.remarks}</p>}
                    </div>

                    <div className="md:col-span-1">
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Document Description <span className="text-red-500">*</span>
                        </label>
                        <input
                            id="description"
                            name="description"
                            maxLength={200}
                            value={formDocumentData.description}
                            onChange={(e) =>
                                setFormDocumentData({
                                    ...formDocumentData,
                                    description: e.target.value,
                                })
                            }
                            className="w-full rounded-md border border-gray-300 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                    </div>

                    <div className="md:col-span-1">
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                            Document <span className="text-red-500">*</span>
                        </label>
                        <div className="relative">
                            <input
                                type="file"
                                onChange={handleFileChange}
                                className="w-full rounded-md border border-gray-300 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                            <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                                <FileText size={18} className="text-gray-400" />
                            </div>
                        </div>
                        {selectedFile && (
                            <p className="text-xs text-gray-500 mt-1">
                                Selected file: {selectedFile.name} ({(selectedFile.size / 1024).toFixed(2)} KB)
                            </p>
                        )}
                    </div>

                    <div className="md:col-span-2">
                        <p className="text-sm text-red-500">* indicates required field</p>
                    </div>
                </form>
            </GlassmorphicModal>

            {/* View Modal using GlassmorphicModal */}
            <GlassmorphicModal
                isOpen={showViewModal}
                onClose={handleCloseViewModal}
                title="Violation Details"
                size="md"
                footer={viewModalFooter}
            >
                {selectedViolation && (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Violation Type</label>
                            <input
                                value={selectedViolation.violationTypeName}
                                readOnly
                                className="w-full rounded-md border border-gray-300 px-4 py-2 bg-gray-50"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Remarks</label>
                            <input
                                value={selectedViolation.remarks}
                                readOnly
                                className="w-full rounded-md border border-gray-300 px-4 py-2 bg-gray-50"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Violation Date</label>
                            <input
                                value={formattedDate(selectedViolation.violationDate)}
                                readOnly
                                className="w-full rounded-md border border-gray-300 px-4 py-2 bg-gray-50"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Amount</label>
                            <input
                                value={selectedViolation.amount}
                                readOnly
                                className="w-full rounded-md border border-gray-300 px-4 py-2 bg-gray-50"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Violation Current Status</label>
                            <input
                                value={selectedViolation.violationCurrentStatus}
                                readOnly
                                className="w-full rounded-md border border-gray-300 px-4 py-2 bg-gray-50"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">Active Status</label>
                            <input
                                value={selectedViolation.activeStatus ? "Active" : "Inactive"}
                                readOnly
                                className="w-full rounded-md border border-gray-300 px-4 py-2 bg-gray-50"
                            />
                        </div>
                    </div>
                )}
            </GlassmorphicModal>

            {/* Approval Modal using GlassmorphicModal */}
            <GlassmorphicModal
                isOpen={showApprovalModal}
                onClose={closeModal}
                title="Violations"
                size="sm"
                footer={approvalModalFooter}
            >
                <p className="text-gray-700">
                    Are you sure you want to update the status of this booking?
                </p>
            </GlassmorphicModal>
        </div>
    );
};

export default Violations;